import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const modules = [
  { to: '/hs-lookup', key: 'hsLookup' },
  { to: '/duty-calc', key: 'dutyCalc' },
  { to: '/doc-generator', key: 'docGenerator' },
  { to: '/tnved-matcher', key: 'tnvedMatcher' },
] as const;

export function HomePage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div>
      <section className="rounded-lg bg-white p-8 shadow-sm ring-1 ring-ntr-primary/10">
        <h2
          data-testid="home-heading"
          className="text-3xl font-semibold text-ntr-primary"
        >
          {t('home.heading')}
        </h2>
        <p
          data-testid="home-subheading"
          className="mt-2 text-base text-ntr-text"
        >
          {t('home.subheading')}
        </p>
        <p className="mt-4 text-sm text-ntr-muted">{t('home.intro')}</p>
      </section>

      <section className="mt-6 grid gap-4 sm:grid-cols-2">
        {modules.map((m) => (
          <Link
            key={m.to}
            to={m.to}
            className="group rounded-lg bg-white p-6 shadow-sm ring-1 ring-ntr-primary/10 transition hover:ring-ntr-accent"
          >
            <h3 className="text-lg font-semibold text-ntr-primary group-hover:text-ntr-accent">
              {t(`home.modules.${m.key}.title`)}
            </h3>
            <p className="mt-2 text-sm text-ntr-muted">
              {t(`home.modules.${m.key}.description`)}
            </p>
          </Link>
        ))}
      </section>
    </div>
  );
}
